export default __webpack_public_path__ + "static/association-2b46a74079dd88c59931b81bfcadba5e.png";